<script setup>
import {
    consentToVimeoEmbed,
    vimeoEmbedConsented,
    vimeoEmbedConsentFailed,
    vimeoEmbedConsentRecording,
} from '../../../../helpers/vimeoEmbedConsent';
import NonEssentialCookiesPrompt from '../../../cookie-banner/NonEssentialCookiesPrompt.vue';

const props = defineProps({
    content: {
        type: Object,
        required: true,
    },
});
</script>
<template>
    <div class="max-w-4xl mx-auto my-6 overflow-hidden rounded-custom shadow-custom">
        <NonEssentialCookiesPrompt
            v-if="!vimeoEmbedConsented"
            class="aspect-video"
            :saving="vimeoEmbedConsentRecording"
            :failed="vimeoEmbedConsentFailed"
            @consent="consentToVimeoEmbed"
        />
        <iframe
            v-else-if="content?.vimeo_video_id"
            title="vimeo-player"
            class="rounded-custom"
            :src="'https://player.vimeo.com/video/' + content.vimeo_video_id"
            style="width: 100%; height: auto; aspect-ratio: 16/9;"
            frameborder="0"
            allowfullscreen
        ></iframe>
    </div>
</template>
